// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1MK4r","col":"styles_col__1q58Q"};